<ng-container *ngIf="property; else noProperty">
	<a type="button" class="link" target="_blank" [href]="query">
		<i *ngIf="showIcon" class="bi bi-geo-alt-fill"> </i>
		{{ addressParts | ellipsis: maxCharacters }}
	</a>
</ng-container>
<ng-template #noProperty> N/A </ng-template>
